import { DependencyList, useRef } from 'react';
import { shallowEqualObjects } from 'shallow-equal';

type EditorFactory<E> = () => E;

interface EditorState<E> {
  editor: E;
  dependencies: DependencyList;
}

export function useEditor<E>(createEditor: EditorFactory<E>, dependencies: DependencyList) {
  const stateRef = useRef<EditorState<E>>();

  if (!stateRef.current || !shallowEqualObjects(stateRef.current.dependencies, dependencies)) {
    stateRef.current = {
      editor: createEditor(),
      dependencies,
    };
  }

  return stateRef.current.editor;
}
